import { hasCapability } from "@/utils/capability";

import { useActiveScopeCapabilities } from "../capability/useActiveScopeCapabilities";

/**
 * License surfaces (`LICENSE:READ` to see, `LICENSE:WRITE` to manage) checked
 * against the active scope's capability set. Strict RBAC — the backend resolver
 * is the single source of truth and the S0 grants give every legacy member the
 * matching keys. See docs/capabilities.md.
 */
export const useLicensePermissions = () => {
  const { capabilities } = useActiveScopeCapabilities();

  const canSeeLicenses = hasCapability(capabilities, "LICENSE:READ");
  const canCreateLicense = hasCapability(capabilities, "LICENSE:WRITE");
  const canUpdateLicense = hasCapability(capabilities, "LICENSE:WRITE");
  const canDeleteLicense = hasCapability(capabilities, "LICENSE:WRITE");

  return {
    canSeeLicenses,
    canCreateLicense,
    canUpdateLicense,
    canDeleteLicense,
  };
};
